var _path, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataRisksMainApp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 7.61116 7.61116 0 17 0H47C56.3888 0 64 7.61116 64 17V47C64 56.3888 56.3888 64 47 64H17C7.61116 64 0 56.3888 0 47V17Z",
    fill: "url(#paint0_radial_6378_127111)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 22.5185,
    fill: "#071A24",
    fillOpacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6378_127111)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7201 40.0329C45.1019 40.0329 46.2222 38.9126 46.2222 37.5308V21.4649C46.2222 20.0831 45.1019 18.9629 43.7201 18.9629H21.4649C20.0831 18.9629 18.9629 20.0831 18.9629 21.4649V43.8299C18.9629 44.2753 19.5015 44.4984 19.8164 44.1834L23.8206 40.1793C23.9143 40.0855 24.0415 40.0329 24.1741 40.0329H43.7201ZM24.8888 23.7036C24.2343 23.7036 23.7036 24.2343 23.7036 24.8888C23.7036 25.5434 24.2343 26.074 24.8888 26.074H34.3703C35.0249 26.074 35.5555 25.5434 35.5555 24.8888C35.5555 24.2343 35.0249 23.7036 34.3703 23.7036H24.8888ZM23.7036 29.6296C23.7036 28.975 24.2343 28.4444 24.8888 28.4444H40.2962C40.9508 28.4444 41.4814 28.975 41.4814 29.6296C41.4814 30.2841 40.9508 30.8147 40.2962 30.8147H24.8888C24.2343 30.8147 23.7036 30.2841 23.7036 29.6296ZM24.8888 33.1851C24.2343 33.1851 23.7036 33.7157 23.7036 34.3703C23.7036 35.0249 24.2343 35.5555 24.8888 35.5555H35.5555C36.21 35.5555 36.7407 35.0249 36.7407 34.3703C36.7407 33.7157 36.21 33.1851 35.5555 33.1851H24.8888Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6378_127111",
    x: 14.9629,
    y: 18.9629,
    width: 35.2588,
    height: 33.3682,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6378_127111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6378_127111",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6378_127111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-23.7037 -40.2963) rotate(53.9876) scale(166.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataRisksMainApp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data_risks_main_app.764a79466689807ab47aaa097ccb7ce5.svg";